import { useReducer } from 'react';

import { PAGE_STATUSES } from './useWorkPageDetailService.js';

const ACTION_TYPES = {
  CHANGE_CONFIGURATION_VALUE: 'CHANGE_CONFIGURATION_VALUE',
  SEARCH_REVIEWS_REQUEST: 'SEARCH_REVIEWS_REQUEST',
  SEARCH_REVIEWS_SUCCESS: 'SEARCH_REVIEWS_SUCCESS',
  SEARCH_REVIEWS_FAILURE: 'SEARCH_REVIEWS_FAILURE'
};

const ACTIONS = {
  changeConfigurationValue: (fieldName, nextValue) => ({
    type: ACTION_TYPES.CHANGE_CONFIGURATION_VALUE,
    payload: {
      fieldName,
      nextValue
    }
  }),
  searchReviewsRequest: () => ({ type: ACTION_TYPES.SEARCH_REVIEWS_REQUEST }),
  searchReviewsSuccess: result => ({ type: ACTION_TYPES.SEARCH_REVIEWS_SUCCESS, payload: { ...result } }),
  searchReviewsFailure: error => ({ type: ACTION_TYPES.SEARCH_REVIEWS_FAILURE, error })
};

const initialState = {
  isRequestInProgress: false,
  statusMessage: '',
  status: PAGE_STATUSES.INITIALIZED,
  errorMessage: null,
  numberOfMatches: null,
  searchConfiguration: {
    dateOfService: '',
    patientName: '',
    finalizedOnStart: '',
    finalizedOnEnd: '',
    mrn: ''
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.CHANGE_CONFIGURATION_VALUE: {
      const { payload } = action;

      return {
        ...state,
        searchConfiguration: {
          ...state.searchConfiguration,
          [payload.fieldName]: payload.nextValue
        }
      };
    }

    case ACTION_TYPES.SEARCH_REVIEWS_REQUEST: {
      return {
        ...state,
        isRequestInProgress: true,
        statusMessage: 'Searching for matching encounter reviews'
      };
    }

    case ACTION_TYPES.SEARCH_REVIEWS_SUCCESS: {
      const { payload } = action;

      return {
        ...state,
        isRequestInProgress: false,
        statusMessage: '',
        numberOfMatches: payload.numberOfMatches
      };
    }

    case ACTION_TYPES.SEARCH_REVIEWS_FAILURE: {
      return {
        ...state,
        isRequestInProgress: false,
        statusMessage: '',
        status: PAGE_STATUSES.ERROR,
        errorMessage: 'Searching for reviews has failed. Please refresh the page.'
      };
    }

    default: {
      throw Error('useClientReviewSearchService default case');
    }
  }
};

function useClientReviewSearchService(service) {
  const [pageState, pageDispatch] = useReducer(reducer, initialState);

  const changeConfigurationValue = (fieldName, nextValue) => {
    pageDispatch(ACTIONS.changeConfigurationValue(fieldName, nextValue));
  };

  const searchReviews = searchConfiguration => {
    pageDispatch(ACTIONS.searchReviewsRequest());

    return service.searchReviews(searchConfiguration)
      .then(responseJson => {
        const { result } = responseJson;

        pageDispatch(ACTIONS.searchReviewsSuccess(result));

        return result;
      })
      .catch(e => pageDispatch(ACTIONS.searchReviewsFailure(e.toString())))
  };

  const boundActions = {
    changeConfigurationValue,
    searchReviews
  };

  return [pageState, boundActions];
}

export { useClientReviewSearchService };
